module.exports = __webpack_public_path__ + "static/media/MorpheusLogo.min.6d8a6c5b.svg";